export {default} from './AcceptByComponent';
